import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { AdSlot } from 'src/ads/components/AdSlot';
import { AdT } from 'src/ads/types';
import { flags } from 'src/app/flags';
import { Portal } from 'src/frames/components/Portal';
import { useScrollToTop } from 'src/frames/components/useScrollToTop';
import { cn } from 'src/frames/utils/cn';
import { BackButton } from 'src/questions/components/BackButton';
import { SkipButton } from 'src/questions/components/SkipButton';
import './AdView.scss';
import * as React from "react";

type PropsT = {
  className?: any;
};

type DefaultPropsT = {
  ad: AdT;
  pageIdx: number;
  summaryPageIdx: number;
  goToNextPage: () => void;
  portalElm: any;
  skip: boolean;
};

export const AdView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    useScrollToTop('SelfTestView', 'AdView');

    const isPreparingTheSummary = props.pageIdx === props.summaryPageIdx - 1;
    const label = isPreparingTheSummary ? 'Zum Ergebnis' : 'Nächste Frage';

    // We need to handle skipping the ad when the user is contentpass authenticated
    React.useEffect(() => {
        if (props.skip) {
            props.goToNextPage();
        }
    }, []);

    return (
      <div
        className={cn(
          'AdView',
          'flex flex-col items-center',
          'px-4 pb-4',
          props.className
        )}
      >
        <Portal elm={props.portalElm}>
          <BackButton />
        </Portal>
        <div className={cn('AdView__Body', 'flex flex-col items-center')}>
          <div className={cn('AdView__AdTitle', 'self-start')}>Anzeige</div>
          <div
            className={cn(
              'AdView__Ad',
              'flex flex-col items-center justify-center',
              'mt-0.5'
            )}
          >
            {flags.enableAds && <AdSlot ad={props.ad} />}
          </div>
        </div>
        <SkipButton className={cn('AdView__Button', 'mt-8')} label={label} />
      </div>
    );
  })
);
